// extracted by mini-css-extract-plugin
export default {"header":"Header_header_vgT6o","subtitle":"Header_subtitle_IPE61","app-toolbar":"Header_app-toolbar_g7Kwe","truncate-text":"Header_truncate-text_bXk8Z"};